<!--
    描述：项目管理下 造价文件
    时间：2020-05-15
    Created by zjj
-->
<template>
	<div class="cost-files">
		<div class="w-page-main">
			<div class="w-page-header">
				<SearchArea ref="searchContent"
							v-model="searchForm.fileName"
							placeholderName="造价文件名称"
							@on-search="onSearch"
							@on-refresh="onRefresh"
							@on-reset="onReset"
							@on-input="onInput">
					<el-form slot="searchform"
							 :model="searchForm"
							 label-width="90px">
						<el-form-item label="造价阶段"
									  prop="phase">
							<el-select v-model="searchForm.phase"
									   placeholder="请选择">
								<el-option v-for="(item, index) in phaseList"
										   :key="'造价阶段' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="上传人"
									  prop="upLoadUserName">
							<el-input placeholder="请输入"
									  v-model="searchForm.upLoadUserName"></el-input>
						</el-form-item>
						<el-form-item label="文件名称"
									  prop="fileName">
							<el-input placeholder="请输入"
									  v-model="searchForm.fileName"></el-input>
						</el-form-item>
						<el-form-item label="文件类型"
									  prop="fileType">
							<el-select v-model="searchForm.fileType"
									   placeholder="请选择">
								<el-option v-for="(item, index) in filesList"
										   :key="'文件类型' + index"
										   :label="item.label"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="计价依据"
									  prop="priceBasis">
							<el-select v-model="searchForm.priceBasis"
									   placeholder="请选择">
								<el-option v-for="(item, index) in basisList"
										   :key="'计价依据' + index"
										   :label="item.sname"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="是否入库"
									  prop="dataState">
							<el-select v-model="searchForm.dataState"
									   placeholder="请选择">
								<el-option v-for="(item, index) in storageList"
										   :key="'是否入库' + index"
										   :label="item.label"
										   :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="上传日期"
									  prop="uploadDate">
							<el-date-picker v-model="searchForm.uploadDate"
											type="date"
											placeholder="请选择日期">
							</el-date-picker>
						</el-form-item>
					</el-form>
				</SearchArea>
				<div class="btnGroups ml10">
					<el-button type="primary"
							   size="small"
							   v-if="roleBtns.includes('file-add') || curSource === '1'"
							   @click="addProject">新增</el-button>
				</div>
			</div>
			<div class="w-page-container">
				<costFilesTable ref="costFilesTable"
								:searchForm="searchForm"
								:projectId="curProjectId"></costFilesTable>
			</div>
		</div>
		<!-- 弹窗 -->
		<el-dialog :title="dialogModel.title"
				   :visible.sync="dialogModel.visible"
				   :width="dialogModel.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 初始新增选择 文件类型等 -->
			<div class="text-center h100 overflow-hidden"
				 v-if="dialogModel.addType === 1">
				<el-form ref="addForm"
						 class="pdr5"
						 :model="addForm"
						 :rules="addRules"
						 label-width="90px">
					<el-row>
						<el-col :span="12">
							<el-form-item label="造价阶段"
										  prop="phase">
								<el-select v-model="addForm.phase"
										   placeholder="请选择"
										   @change="onSelect">
									<el-option v-for="(item, index) in phaseList"
											   :key="'造价阶段' + index"
											   :label="item.sname"
											   :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="计价依据"
										  prop="priceBasis">
								<el-select v-model="addForm.priceBasis"
										   placeholder="请选择">
									<el-option v-for="(item, index) in basisList"
											   :key="'造价依据' + index"
											   :label="item.sname"
											   :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="文件类型"
								  class="text-left">
						<el-radio v-model="addForm.fileType"
								  label="1"
								  disabled
						>Excel</el-radio>
						<el-radio v-model="addForm.fileType"
								  label="0">XML</el-radio>
					</el-form-item>
					<el-row>
						<el-col :span="24">
							<el-form-item label="上传文件"
										  :rules="[{required: true}]">
								<my-upload :aid="aid"
										   mode="add"
										   ref="myUpload"
										   :multiple="false"
										   :maxNum="1"
										   :acceptType="acceptType"></my-upload>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<!-- excel 或 xml 的文件处理 -->
			<div class="text-center h100 overflow-hidden"
				 v-if="dialogModel.addType === 2">
				<cost-structure-list ref="structureList"
									 v-if="addForm.fileType === '1'"
									 :phase="addForm.phase"></cost-structure-list>
				<xml-preview v-else
							 :tableData="addForm.sheetList"
							 :fileName="addForm.param"
							 ref="xmlPreview"
							 :unitList="DanWeiByProjectList"
							 :phase="addForm.phase"></xml-preview>
			</div>
			<!-- excel 的文件预览页面 -->
			<div class="text-center h100 overflow-hidden"
				 v-if="dialogModel.addType === 3">
				<excel-preview :fileName="addForm.param1"
							   :tableData="addForm.treeData"></excel-preview>
			</div>
			<div slot="footer"
				 v-if="dialogModel.type === 'add'"
				 class="dialog-footer text-center">
				<el-button @click="handleClose"
						   size="small">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doConfirm">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 上传进度 -->
		<el-dialog title="上传进度"
				   width="65%"
				   class="progressDialog"
				   :visible.sync="progressData.show"
				   :close-on-click-modal="false"
				   :close-on-press-escape="false"
				   :show-close="false"
				   :append-to-body="true">
			<div>
				<el-row v-for="(i, index) in progressData.eventList"
						:key="'eventList' + index">
					<el-col :span="8">
						<div class="inputTitle">
							{{ i.name }}
						</div>
					</el-col>
					<el-col :span="16">
						<el-row class="progressBox"
								:gutter="20">
							<el-col :span="10"
									class="progressCol">
								<el-progress :text-inside="true"
											 :stroke-width="26"
											 :percentage="i.progress"></el-progress>
							</el-col>
							<el-col :span="12"
									class="progressInfo">
								{{ i.progressInfo }}&nbsp;
								<i class="el-icon-loading"
								   v-show="i.progressLoading"></i>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import SearchArea from 'components/searchArea/searchArea'
import costFilesTable from '../cost-files/cost-files-table'
import myUpload from 'components/upload/upload'
import xmlPreview from '../cost-files/xml-preview'
import costStructureList from '../cost-files/cost-structure-list'

// js
import {
	getXmlview,
	selectDanWeiByProject,
	costSave
} from '@/api/modules/project_costfiles'
import { deleteFile } from '@/api/modules/upload'
import { mapState } from 'vuex'
export default {
	name: 'Cost-files',
	components: {
		SearchArea,
		costFilesTable,
		myUpload,
		xmlPreview,
		costStructureList
	},
	data() {
		return {
			//搜索表单
			searchForm: {
				phase: '', // 造价阶段
				upLoadUserName: '', // 上传人
				fileName: '', // 文件名称
				fileType: '', // 文件类型
				priceBasis: '', // 计价依据
				dataState: '', // 是否入库
				uploadDate: '' // 上传日期
			},
			projectId: '', //项目id
			//弹出对话框
			dialogModel: {
				title: '新增文件',
				visible: false,
				width: '650px',
				type: 'add',
				addType: 0
			},
			//重置表单数据
			resetaddForm: {
				danWeiId: ''
			},
			//弹窗表单
			addForm: {
				phase: '', // 造价阶段
				priceBasis: '', // 计价依据
				fileType: '0', // 文件类型
				param: '', // 造价文件名称
				param1: '', // 结构名称
				treeId: '', // 当前树id
				isData: '', // 当前是否有数据
				sheetList: [], // 数组
				treeData: [] // 格式化后的树结构数组
			},
			DanWeiByProjectList: [], //工程数据
			addRules: {
				// 造价阶段
				phase: [
					{
						type: 'string',
						required: true,
						message: '请选择造价阶段',
						trigger: 'change'
					}
				],
				// 计价依据
				priceBasis: [
					{
						type: 'string',
						required: true,
						message: '请选择计价依据',
						trigger: 'change'
					}
				]
			},
			btnLoading: false,
			fileList: [],
			aid: '', // 上传组件业务表ID
			pageLoading: false,
			// 进度条
			saveFileId: [],
			progressData: {
				show: false,
				eventList: [],
			},
			progressOverWatch: null,
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.DanWeiByProject()
		})
	},
	methods: {
		//造价文件-选择xml文件点击确定跳转页面中单位工程的下拉列表接口
		DanWeiByProject(val) {
			selectDanWeiByProject({ id: this.curProjectId }).then(res => {
				if (res.code === 0) {
					this.DanWeiByProjectList = res.data
				}
			})
		},

		// 点击新增文件
		addProject() {
			this.dialogModel.visible = true
			this.dialogModel.addType = 1
		},

		// 筛选框输入事件
		onInput(val, attr) {
			this.searchForm[attr] = val
		},

		// 筛选框确认查询事件
		onSearch() {
			this.$refs.costFilesTable.getTableData()
		},

		// 查询组件 刷新按钮
		onRefresh() {
			// 先重置
			this.onReset()
			this.$refs.costFilesTable.getTableData()
		},

		// 筛选框重置事件
		onReset() {
			for (let k in this.searchForm) {
				this.searchForm[k] = ''
			}
		},

		//造价阶段选择事件
		onSelect(val) {
			if (val === '1007001') {
                let _path = this.$route.path === '/projectAnalysis' ? '/projectAnalysis/estimate-price' : '/project-management/estimate-price'
				this.$router.push({
					// path: '/project-management/estimate-price',
					path: _path,
					query: this.$route.query
				})
			}
		},
		// 关闭弹窗事件
		handleClose() {
			this.dialogModel.visible = false
			this.dialogModel.title = '新增文件'
			this.dialogModel.type = 'add'
			this.dialogModel.width = '650px'
			this.btnLoading = false
			// 清空addForm
			this.$refs.myUpload ? this.$refs.myUpload.clearFiles() : ''
			this.addForm.phase = ''
			this.addForm.priceBasis = ''
			this.addForm.fileType = '0'
			this.addForm.param = ''
			this.addForm.param1 = ''
			this.addForm.treeId = ''
			this.addForm.isData = ''
			this.addForm.sheetList = []
			this.addForm.treeData = []

			// 删除附件
			if (this.saveFileId.length > 0) {
				this.deleteFile()
			}
		},
		// 弹窗点击确认
		doConfirm() {
			this.btnLoading = true

			// 第一级确定
			if (this.dialogModel.addType === 1) {
				let _addList = this.$refs.myUpload.addList
				if (_addList.length === 0) {
					this.$message.warning('请上传具体的文件!')
					this.resetBtnloading()
					return
				}
				this.$refs.addForm.validate(valid => {
					if (valid) {
						// 存储当前的文件
						this.fileList = _addList
						// 进度条
						this.progressData.eventList = _addList.filter(x => !x.id)
						this.progressData.eventList.map((i) => {
							i.progress = 0
							i.progressLoading = true
						})

						// 如果是xml 直接预览
						if (this.addForm.fileType === '0') {
							this.doPreviewXml()
						} else {
							this.dialogModel.addType = 2
							this.dialogModel.title =
								this.addForm.fileType === '1'
									? '选择上传文件所属节点'
									: 'xml 导入数据预览'
							this.dialogModel.type = 'add'
							this.dialogModel.width =
								this.addForm.fileType === '1'
									? '650px'
									: '1300px'
							this.btnLoading = false
						}
					} else {
						this.resetBtnloading()
					}
				})
			} else if (this.dialogModel.addType === 2) {
				// 如果是 excel
				if (this.addForm.fileType === '1') {
					// 第二级确定
					let _choose = this.$refs.structureList.chooseName
					if (_choose === '') {
						this.$message.warning('请选择一个文件节点!')
						this.resetBtnloading()
					} else {
						// 预览文件
						this.btnLoading = false
						// 存储当前信息
						this.addForm.isData = this.$refs.structureList.isData
						this.addForm.treeId = _choose
						this.doPreview(_choose)
					}
				} else {
					this.$refs.xmlPreview.doSubmit().then((res => {
						// console.log(res)
						if (res) {
							// 赋值
                        	this.resetaddForm.param1 = this.$refs.xmlPreview.leftData

							let list = []
							this.$refs.xmlPreview.leftData.forEach(x => {
								if (x.danWeiId) {
									list.push(x.danWeiId)
								}
							})
							this.addForm.isData = '1'
							this.resetaddForm.danWeiId = list.join(',')

							this.doSave()
						} else {
							this.btnLoading = false
						}
					}))
					
				}
			} else {
				// 确认上传
				this.doSave()
			}
		},
		// 文件预览 --xml
		doPreviewXml(callBackFn) {
			let formData = new FormData()
			for (let item of this.fileList) {
				formData.append('file', item)
			}

			formData.append('fileType', this.addForm.fileType === '0' ? 0 : 1)
			formData.append('phase', this.addForm.phase)
			formData.append('priceBasis', this.addForm.priceBasis)
			formData.append('projectId', this.curProjectId)

			// loading
			// this.pageLoading =  this.$loading({
   //      	  	lock: true,
   //      	  	text: '正在解析中...',
   //      	  	spinner: 'el-icon-loading',
   //      	})

			// xml 预览操作
			this.progressData.show = true
			getXmlview(formData, this.progressFn, 0)
				.then(res => {
					// loading
					// this.pageLoading.close()

					if (res.code === 0) {
						// 进度条
						this.progressData.eventList[0].progressInfo = '解析成功'
						this.progressData.eventList[0].progress = 100
						this.progressData.eventList[0].progressLoading = false
						let data = this.progressData.eventList[0]
						this.$set(this.progressData.eventList, 0, data)

						setTimeout(() => {
							this.progressData.show = false
							this.progressData.eventList = []
							this.saveFileId = res.data.fileId

							this.addForm.sheetList = res.data.param1
							this.addForm.param = res.data.param3
							this.dialogModel.addType = 2
							this.dialogModel.title = 'xml 导入数据预览'
							this.dialogModel.type = 'add'
							this.dialogModel.width = '1300px'
							this.btnLoading = false
							this.addForm.fileType = res.data.param2.fileType
	
							this.resetaddForm = res.data
						}, 500)
					} else {
						this.progressData.eventList[0].progressInfo = '解析失败，请重新上传！'
						this.progressData.eventList[0].progressLoading = false
						let data = this.progressData.eventList[0]
						this.$set(this.progressData.eventList, 0, data)

						this.resetBtnloading()
					}
				})
				.catch(err => {
					this.progressData.eventList[0].progressInfo = '上传失败！'
					this.progressData.eventList[0].progressLoading = false
					let data = this.progressData.eventList[0]
					this.$set(this.progressData.eventList, 0, data)

					// this.pageLoading.close()
					this.resetBtnloading()
				})
		},

		// 上传进度函数
		progressFn(progressEvent, index) {
			if (this.progressData.eventList.length > 0) {
				this.progressData.eventList[index].progress =
					((progressEvent.loaded / progressEvent.total) * 100) | 0

				// 特殊处理
				if (progressEvent.loaded / progressEvent.total >= 0.9) {
					this.progressData.eventList[index].progress = 90
				}
				if ((progressEvent.loaded / progressEvent.total) === 1) {
					this.progressData.eventList[index].progressInfo =
						'正在解析文件, 请稍后....'
				} else {
					this.progressData.eventList[index].progressInfo = '正在上传'
				}
				let data = this.progressData.eventList[index]
				this.$set(this.progressData.eventList, index, data)
			}
		},

		// 文件预览 ---excel
		doPreview(danWeiId) {},

		// 确认上传excel或xml
		doSave() {
			let params = JSON.parse(JSON.stringify(this.resetaddForm))
			params.param2.projectId = this.curProjectId
			params.param2.fileName = this.resetaddForm.param3
			let resetparam1 = params.param1.filter(x => {
				return x.danWeiId !== '' && x.danWeiId !== undefined
			})
			let { param3, ...object } = params
			params = object
			params = { ...params, param1: resetparam1 }

			// loading
			this.pageLoading =  this.$loading({
        	  	lock: true,
        	  	text: '正在保存中...',
        	  	spinner: 'el-icon-loading',
        	})
			// 保存excel
			costSave(params)
				.then(res => {
					this.btnLoading = false
					// loading
					this.pageLoading.close()

					if (res.code === 0) {
						this.$message.success(res.msg)
						this.handleClose()
						// 重新渲染数据
						this.$refs.costFilesTable.getTableData()
					} else {
						this.$message.error(res.msg)
					}
				})
				.catch(error => {
					// loading
					this.pageLoading.close()
					this.resetBtnloading()
				})
		},

		// 恢复按钮
		resetBtnloading() {
			setTimeout(() => {
				this.btnLoading = false
				this.progressData.show = false
				this.progressData.eventList = []
			}, 2000)
		},

		// 删除文件
		deleteFile() {
			deleteFile({id: this.saveFileId})
				.then(res => {
					this.saveFileId = []
				})
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		// 当前项目ID
		curProjectId() {
			return this.$route.query.projectId
		},
		// 计价依据
		...mapState('dict', {
			phaseList: state => state.zjjd,
			basisList: state => state.jjyj
		}),
		// 文件类型
		filesList() {
			return [
				{
					label: 'excel',
					value: '1'
				},
				{
					label: 'xml',
					value: '0'
				}
			]
		},
		// 入库数组
		storageList() {
			return [
				{
					label: '已入库',
					value: '1'
				},
				{
					label: '未入库',
					value: '0'
				}
			]
		},
		// 文件上传 文件类型
		acceptType() {
			return this.addForm.fileType === '1'
				? ['xls', 'xlsx']
				: ['xml', 'XML']
		},
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	}
}
</script>

<style scoped lang="less">
@import '../cost-files/cost-fils-updat.less';
</style>
